<form [formGroup]="parentForm">
    <div class="row mt-5">
        <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
                <mat-label>First Name</mat-label>
                <input id="first-name" matInput formControlName="firstName" placeholder="First Name" />
                <mat-error>
                    <app-invalid-field [field]="'firstName'" [messageList]="errorList" />
                </mat-error>
            </mat-form-field>
        </div>

        <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
                <mat-label>Last Name</mat-label>
                <input id="last-name" matInput formControlName="lastName" placeholder="Last Name" />
                <mat-error>
                    <app-invalid-field [field]="'lastName'" [messageList]="errorList" />
                </mat-error>
            </mat-form-field>
        </div>
    </div>

    <lib-phone-input
        #phoneInputComponent
        [isFormEnabled]="true"
        [countryReadonly]="true"
        [whiteListCountryCodes]="whiteListCountryCodes"
    />

    <mat-form-field appearance="outline" class="w-100">
        <mat-label>Email</mat-label>
        <input id="email" matInput formControlName="email" placeholder="john.doe@example.com" />
        <mat-error>
            <app-invalid-field [field]="'email'" [messageList]="errorList" />
        </mat-error>
    </mat-form-field>

    <div class="email-container p-4 mb-5">
        <p class="two-factor-auth mb-2">TWO FACTOR AUTHENTICATION</p>
        <p class="two-factor-auth-description mb-2">
            This is an extra layer of security that helps protect your account by requering a form of verification
            before granting access. It adds an additional step to the usual username and password login process.
        </p>

        <p class="email-value pt-2">{{ parentForm.controls['email'].value }}</p>
        <p class="email-legend">We will send an email with a code to your email address.</p>
    </div>

    <app-next-previous-buttons
        [disabled]="parentForm.invalid || phoneInputComponent.phoneForm.invalid"
        [previousText]="'Reset Form'"
        [customPreviousHandler]="true"
        [customNextHandler]="true"
        (previous)="cancel()"
        (next)="next()"
    />
</form>

<ng-template #twoFactorModal>
    <app-two-factor [module]="module" />
</ng-template>
